export const INVALID_ACCOUNT_STRIPE_ERROR = 'Invalid account.';
export const INVALID_ACCOUNT_FRIENDLY_ERROR =
    'Your card, or the account connected to it, appears invalid. Double check your details and contact your card issuer to ensure working order. Alternatively, please try a different card if you have access to one.';
export const FAILED_AUTH_PAYMENT_ERROR =
    'We are unable to authenticate your payment method. Please choose a different payment method and try again.';

export const CARD_ADD_DECLINED_STRIPE_ERROR = 'Card declined';
export const CARD_ADD_DECLINED_FRIENDLY_ERROR =
    'Card declined. Double check your details and contact your card issuer to ensure working order. Alternatively, please try a different card if you have access to one.';

export const CARD_ADD_ERROR_STRIPE_ERROR = 'Card error';
export const CARD_ADD_ERROR_FRIENDLY_ERROR =
    'Card error. Double check your details and contact your card issuer to ensure working order. Alternatively, please try a different card if you have access to one.';

export const CARD_ADD_INVALID_REQ_STRIPE_ERROR = 'Invalid request';
export const CARD_ADD_INVALID_REQ_FRIENDLY_ERROR =
    'Card error. Double check your details and contact your card issuer to ensure working order. Alternatively, please try a different card if you have access to one.';

export const DEFAULT_ERROR =
    'There was an issue confirming your order. Please check your email to see if your order was successful. If no email is received you are safe to re-attempt your order.';

const errorMap = {
    [INVALID_ACCOUNT_STRIPE_ERROR]: INVALID_ACCOUNT_FRIENDLY_ERROR,
    [FAILED_AUTH_PAYMENT_ERROR]: FAILED_AUTH_PAYMENT_ERROR,
    [CARD_ADD_DECLINED_STRIPE_ERROR]: CARD_ADD_DECLINED_FRIENDLY_ERROR,
    [CARD_ADD_ERROR_STRIPE_ERROR]: CARD_ADD_ERROR_FRIENDLY_ERROR
};

// eslint-disable-next-line import/prefer-default-export
export const getFriendlyPaymentError = (error, defaultErrorMessage) => {
    let errMessage = error.message;
    let defaultErr = defaultErrorMessage;

    if (error.force) {
        if (error.detail) {
            return `${error.message}: ${error.detail}`;
        }
        return error.message;
    }

    if (error.response) {
        errMessage = error.response.data.error;
        defaultErr = error.response.data.error;
    }

    return errorMap[errMessage] || defaultErr;
};

export const isSafePaymentError = error => {
    return error !== DEFAULT_ERROR;
};

export const isValidPhoneNumber = (number, countryCode) => {
    if (countryCode === 'GB') {
        return /^(?:07|\+?447)(?:\d\s?){9}$/.test(number);
    }

    if (countryCode === 'IE') {
        return /^(?:08|\+?3538)(?:\d\s?){8}$/.test(number);
    }

    return false;
};

export const getInvalidPhoneNumberMessage = countryCode => {
    if (countryCode === 'GB') {
        return 'Please provide a valid UK (+447) mobile number';
    }

    if (countryCode === 'IE') {
        return 'Please provide a valid ROI (+3538) mobile number';
    }

    return 'Please provide a valid UK or IE mobile number';
};
